import { sizeSelectors as selector } from "../Selectors/index";
import Service from "../../Service/Item-master/itemSize.service";
import { openSnackbar } from "./snackbarActions";

export const getSize = () => {
  return {
    type: selector.GET,
  };
};

export const getSizeSuccess = (payload) => {
  return {
    type: selector.GET_SUCCESS,
    payload: payload,
  };
};

export const fetchSize = () => {
  return async (dispatch) => {
    dispatch(getSize());
    try {
      const res = await Service.getAll();
      dispatch(getSizeSuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};